import { useLocation, useNavigate } from "react-router";

// project imports
import ActionButton from "components/ActionButton";

// mui
import { Box, Typography } from "@mui/material"
import { height } from "@mui/system";

export default function NotFoundPage() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/login')
  }

  return (
    <Box
      sx={{
        minHeight: '90vh', // минимальная высота на весь экран
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          flexDirection: 'column',
        }}
      >
        <Typography
            sx={{
            fontSize: '3rem',
            fontWeight: '500',
            mb: '0.5rem',
            lineHeight: 1
          }}
        >
        404
        </Typography>

        <Typography
          sx={{
            mb: '1rem',
            fontWeight: '300',
            fontSize: '1.2rem'
          }}
        >
          Страница не найдена: {pathname}
        </Typography>

        <ActionButton
          onClick={handleBack}
          variant='empty'
          sx={{
            width: {xs: '12rem'},
            height: {xs: '2.5rem'}
          }}
        >
          Вернуться назад
        </ActionButton>
      </Box>
    </Box>
  )
}